export default "__VITE_ASSET__CNNW7WHu__"